module.exports = [
  { id: 1, name: 'Default' },
  { id: 2, name: 'White' },
  { id: 3, name: 'Yellow' },
  { id: 4, name: 'Pink' },
  { id: 5, name: 'Green' },
  { id: 6, name: 'Black' },
  { id: 7, name: 'Light Pink' },
  { id: 8, name: 'Light Blue' },
];
